import React, { useEffect, useState } from "react";
import { api } from "../api";
import { MediaEmbed } from "../components/MediaEmbed";
import { SEO } from "../components/SEO";
import { usePageContent, resolveMediaUrl } from "../components/PageContent";
import { usePageBlocks, PageBlocksRenderer } from "../components/PageBlocks";

export default function Evidence() {
  const [items, setItems] = useState([]);
  const c = usePageContent("evidence", {
    eyebrow: "State's Exhibit",
    title: "Evidence",
    body: "Photographs, clips, dispatches. Submitted into the public record. No comment.",
  });
  const blocks = usePageBlocks("evidence");
  useEffect(() => {
    api.get("/evidence").then((r) => setItems(r.data)).catch(() => {});
  }, []);
  const bg = resolveMediaUrl(c.image);

  return (
    <div className="bg-asphalt text-bone min-h-screen" data-testid="evidence-page">
      <SEO title={c.title || "Evidence"} description={c.body} image={bg} path="/evidence" />
      <section
        className="relative py-16 overflow-hidden"
        style={
          c.show_media && bg
            ? { backgroundImage: `url(${bg})`, backgroundSize: "cover", backgroundPosition: "center" }
            : undefined
        }
        data-testid="evidence-hero"
      >
        {c.show_media && bg && c.overlay && (
          <div className="absolute inset-0 bg-asphalt/80 mix-blend-multiply pointer-events-none" />
        )}
        <div className="relative max-w-[1400px] mx-auto px-5 lg:px-10">
          {c.eyebrow && <div className="font-mono text-xs uppercase tracking-[0.35em] text-terra mb-3">✦ {c.eyebrow}</div>}
          <h1 className="font-display text-6xl sm:text-7xl uppercase leading-none tracking-tighter whitespace-pre-line">{c.title}</h1>
          {c.subtitle && <p className="font-western text-2xl text-bone/80 max-w-2xl mt-4">{c.subtitle}</p>}
          {c.body && <p className="font-western text-2xl text-bone/80 max-w-2xl mt-4 whitespace-pre-line">{c.body}</p>}
        </div>
      </section>
      <div className="tape-divider" />
      <PageBlocksRenderer blocks={blocks} testid="evidence-blocks" />
      <section className="max-w-[1400px] mx-auto px-5 lg:px-10 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 auto-rows-[180px] md:auto-rows-[240px]">
          {items.map((e, i) => {
            const span =
              e.span === "large"
                ? "col-span-2 row-span-2"
                : e.span === "wide"
                ? "col-span-2"
                : e.span === "tall"
                ? "row-span-2"
                : "";
            return (
              <div key={e.id} data-testid={`evidence-item-${i}`} className={`relative border-2 border-bone overflow-hidden bg-card-dark ${span}`}>
                <MediaEmbed item={e} />
                {e.caption && (
                  <div className="absolute bottom-0 left-0 right-0 px-3 py-2 bg-asphalt/85">
                    <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-bone">{e.caption}</div>
                    {e.location && (
                      <div className="font-mono text-[9px] uppercase tracking-[0.3em] text-bone/60">
                        ⌖ {e.location}
                      </div>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
}
